import styled from 'styled-components';
import {BaseColumnWrap, CenteredSpaceWrap} from '../../../../CommonStyleUtils/dwebCommon.styles';
import HappyRupeeIcon from '@stencil/icons/src/HappyRupeeIcon/HappyRupeeIcon';

// import Image from '../../../common/Image/Image';
import Image from '@stencil/image';

export const SliderOuterWrapper = styled.section(
  props => `
    max-width:120rem;
    margin-bottom: ${props.theme.spacing.base};
    margin-top: ${props.theme.spacing.xxlarge};
    `,
);

export const SliderHotelsOuterWrapper = styled.div(
  props => `
    width: 100%;
    overflow: hidden;
    display: flex;
    height: 26.4rem;
    `,
);

export const SliderHotelInnerWrapper = styled.div(
  props => `
    width: 100%;
    display: flex;
    overflow: auto;
    height: 29rem;
    `,
);

export const SliderRelatedHotelsList = styled.ul(
  props => `
        width: 330rem;
        list-style-type: none;
        padding: ${props.theme.spacing.custom(7)} ${props.theme.spacing.small};
        flex-direction: row;
        align-items: flex-start;
        display: flex;
        >li{
            width: 34rem;
            height: 25rem;
            // margin-right: ${props.theme.spacing.small};
            flex-direction: row;
            align-items: center;
            display: flex;
            // border:1px solid black;
        }
    `,
);

export const SliderListHoterOuterWrp = styled(BaseColumnWrap)(
  props => `
        height: 26.4rem;
        border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
        padding: ${props.theme.spacing.base};
        cursor: pointer;
    `,
);

export const SliderListHotelImageWrap = styled.div(
  props => `
        width: 100%;
        height: 11.5rem;
        display: flex;
        position:relative;
    `,
);

export const SliderListHotelImg = styled(Image)(
  props => `
        display: flex;
        height: 11.5rem;
        width: 100%;
        object-fit: cover;
        border-radius: ${props.theme.misc.borderRadius.base};
    `,
);

export const SliderHotelInfoWrapper = styled.div(
  props => `
        display: flex;
        flex-direction:column;
        height:13rem;
        width: 100%;
        justify-content: flex-end;
        padding-top:${props.theme.spacing.small};
    `,
);

export const SliderHotelInfoInnerWrapper = styled.div(
  props => `
        display: flex;
        
    `,
);

export const SliderHotelNameInfoWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    width: 60%;
    `,
);

export const StarRatingWrapperSpan = styled.span(
  props => `
  display: flex;
  margin-right: ${props.theme.spacing.base};
  margin-top: ${props.theme.spacing.small};
  margin-bottom: ${props.theme.spacing.small};
`,
);

export const SliderHotelPriceInfoWrap = styled.div(
  props => `
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      width: 40%;
    `,
);

export const SliderHotelNameText = styled.p(
  props => `
      font-size: ${props.theme.font.custom(16)};
      font-family: ${props.theme.font.fontFamily};
      font-weight: bold;
      // padding: ${props.theme.spacing.small} 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `,
);

export const SliderHotelLocationText = styled.span(
  props => `
        padding-bottom: ${props.theme.font.small};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
);

export const SliderMainContentWrapper = styled.div(
  props => `
        background-color:${props.theme.colors.goWhite.base};
        align-items: center;
        border-radius: ${props.theme.misc.borderRadius.large};
        display: flex;
    `,
);

export const PriceOuterWrap = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
    `,
);

export const OriginalPriceStrike = styled.div(
  props => `
      color: ${props.theme.colors.downriver.medium};
      text-decoration: line-through;
      font-size: ${props.theme.font.base};
      display: inline-flex;
    `,
);

export const RuppeStrike = styled(HappyRupeeIcon)(
  props => `
    margin-top: ${props.theme.spacing.custom(2)};
    fill: ${props.theme.colors.downriver.medium};
    height:1rem;
    width:1rem;
  `,
);

export const RuppeAskingPrice = styled(HappyRupeeIcon)(
  props => `
        margin-top: ${props.theme.spacing.custom(7)};
        width: 1.5rem;
        height: 1.5rem;
        fill: ${props.theme.colors.downriver.base};
    `,
);

export const ExtraTaxesText = styled.p(
  props => `
        font-size: ${props.theme.font.small};
        display: inline-flex;
    `,
);

export const RuppeExtraTax = styled(HappyRupeeIcon)(
  props => `
        margin-top: ${props.theme.spacing.custom(4)};
        width: .65rem;
        height: .65rem;
        fill: ${props.theme.colors.downriver.base};
    `,
);

export const PerNightText = styled.p(
  props => `
        color: ${props.theme.colors.downriver.medium};
        padding-top: ${props.theme.spacing.xsmall};
    `,
);

export const SliderHeaderWrapper = styled(CenteredSpaceWrap)(
  props => `
        padding-bottom: ${props.theme.spacing.large};
    `,
);

export const SliderHeaderSubText = styled.p(
  props => `
        display: flex;
        font-size: ${props.theme.font.custom(16)};
        color: ${props.theme.colors.downriver.dark};
        padding: ${props.theme.spacing.small} 0 0;
    `,
);

export const SliderHeaderArrowWrapInner = styled.div(
  props => `
        width: 7.5rem;
        box-shadow: 0 .1rem .4rem 0 ${props.theme.colors.shadow.light};
        background-color: ${props.theme.colors.goWhite.base};
        border-radius: ${props.theme.misc.borderRadius.custom(20)}
    `,
);

export const SliderArrowWrap = styled.button(
  props => `
        padding: ${props.theme.spacing.base};
        cursor: pointer;
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.goBrandBlue.base};
        display: inline-flex;
        background:${props.theme.colors.goWhite.base};
        border-radius:50%;
        &:hover{
            color: ${props.theme.colors.goBrandBlue.base};
        }
        border: none;
        box-shadow: none;
        outline: none;
        border-radius: 50%;
    `,
);

export const SliderTypeOuterWrapper = styled.div(
  props => `
    width: 23rem;
    position: relative;
    overflow: hidden;
    border-radius: ${props.theme.misc.borderRadius.large} 0 0 ${props.theme.misc.borderRadius.large};
    flex-direction: column;
    display: flex;
    box-shadow: 0 1px 5px ${props.theme.colors.shadow.base};
  `,
);

export const SliderGoStayOverlay = styled.div(
  props => `
    display:flex;
    position:absolute;
    bottom:0;
    background: ${props.theme.colors.goWhite.base};
    border-radius:50%;
    border: 0.1rem solid ${props.theme.colors.goWhite.base};
    margin:${props.theme.spacing.small};
    z-index:${props.theme.misc.zIndex.xxsmall};
  `,
);
export const SliderQuarterCircle = styled.div(
  props => `
  width: 4rem;
  height: 4rem;
  background: ${props.theme.colors.goBrandBlue.base};
  border-radius: 0 100px 0 0;
  -moz-border-radius: 0 100px 0 0;
  -webkit-border-radius: 0 100px 0 0;
  position:absolute;
  bottom:0;
  z-index:0;
  `,
);

export const SliderLeftImgWrap = styled(Image)(
  props => `
  object-fit: cover;
`,
);

export const GoSafeLogoImg = styled(Image)(
  props => `
    width:5rem;
    position: relative;
    top: .5rem;
    `,
);
